import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const ItemCountStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
})`
  ${({ theme }) => css`
    padding-left: ${theme.spacings[600]};
    padding-right: ${theme.spacings[600]};
    height: calc(${theme.spacings[700]} + ${theme.spacings[200]});
    border-radius: ${theme.radii[700]};
    border: 1px solid ${theme.colors.blue[800]};
  `}
`;
